import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { myProfile } from '../signals/profile';
import { effect } from '@preact/signals';
import { scrolling } from '../signals/feedScrollPage';
import { isMobile } from '../utils/data';
import { hasActivePlan, isCreator } from '../signals/creator';
import { getSessionObject, setSessionObject } from '../utils/storage';

type Props = {
  selectedTabIndex?: number;
  isHomePage?: boolean;
};

const Header: React.FC<Props> = ({ selectedTabIndex, isHomePage }) => {
  const [isScrollingPage, setIsScrollingPage] = useState(false);
  const [showBannerMessage, setShowBannerMessage] = useState(false);

  const navigate = useNavigate();

  effect(() => {
    if (!isMobile()) return;

    if (!isScrollingPage && scrolling.value) {
      setIsScrollingPage(true);
    } else if (isScrollingPage && !scrolling.value) {
      setIsScrollingPage(false);
    }
  });

  useEffect(() => {
    const hasAlreadyClosedBanner = getSessionObject('hasAlreadyClosedBanner');
    if (!hasAlreadyClosedBanner && isCreator.value && !hasActivePlan.value) {
      setShowBannerMessage(true);
    }
  }, []);

  return (
    <>
      <div
        className="nav-header shadow-xs border-0"
        style={{
          opacity: isScrollingPage ? 0 : 1,
          transform: isScrollingPage ? 'translateY(-12px)' : 'translateY(0)',
          transition: 'opacity .35s ease, transform .35s ease',
          pointerEvents: isScrollingPage ? 'none' : 'auto',
        }}
      >
        <div className="nav-top d-flex justify-content-between">
          <Link to={isCreator.value ? '/myprofile' : '/'}>
            <img
              src="assets/images/logo.png"
              style={{
                maxHeight: 145,
                maxWidth: 145,
                transition: 'filter .3s ease',
                filter: isScrollingPage ? 'blur(2px)' : 'none',
              }}
              alt=""
            />
          </Link>
        </div>
        {isMobile() && isHomePage && (
          <div className="d-flex flex-row align-items-center">
            <div
              style={{
                width: 50,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'row',
                padding: 5,
                marginRight: 5,
                borderRadius: 10,
                cursor: 'pointer',
                border: `${
                  selectedTabIndex !== 0 ? '3px solid #f4f4f4' : '0px'
                }`,
                backgroundColor: selectedTabIndex === 0 ? '#f92e5a' : '#ffffff',
                transition:
                  'background-color .3s ease, border .3s ease, transform .25s ease',
                transform: selectedTabIndex === 0 ? 'scale(1.05)' : 'scale(1)',
              }}
              onClick={() => {
                navigate('/');
              }}
              className="shadow-xss"
            >
              <i
                className={`${
                  selectedTabIndex === 0 ? 'text-white' : 'text-grey-600'
                } feather-trending-up font-sm`}
              ></i>{' '}
            </div>
            <div
              style={{
                borderRadius: 10,
                width: 50,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: selectedTabIndex === 1 ? '#f92e5a' : '#ffffff',
                padding: 5,
                cursor: 'pointer',
                border: `${
                  selectedTabIndex !== 1 ? '3px solid #f4f4f4' : '0px'
                }`,
                transition:
                  'background-color .3s ease, border .3s ease, transform .25s ease',
                transform: selectedTabIndex === 1 ? 'scale(1.05)' : 'scale(1)',
              }}
              onClick={() => {
                navigate('/feed')
              }}
              className="shadow-xss"
            >
              <i
                className={`${
                  selectedTabIndex === 1 ? 'text-white' : 'text-grey-600'
                } feather-unlock font-sm`}
              ></i>{' '}
            </div>
          </div>
        )}
        <span
          className="p-2 pointer text-center ms-auto menu-icon"
          id="dropdownMenu3"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        />
        <Link to="/menu" className="p-0 ms-3 menu-icon">
          <figure
            className="avatar"
            style={{ transition: 'transform .3s ease' }}
          >
            {myProfile.value.profile.avatar ? (
              <img
                src={myProfile.value.profile.avatar}
                alt="avater"
                className="float-right p-1 bg-white rounded-circle w60"
                style={{ transition: 'box-shadow .3s ease' }}
              />
            ) : (
              <i className="feather-user font-xl text-warning" />
            )}
          </figure>
        </Link>
      </div>
      {showBannerMessage && (
        <div
          className="alert d-flex justify-content-between align-items-center"
          style={{
            marginBottom: 0,
            padding: '10px 20px',
            fontSize: '14px',
            position: 'fixed',
            zIndex: 999,
            right: 0,
            left: 0,
            top: 0,
            marginTop: 75,
            backgroundColor: '#fff8e1', // Softer yellow background
            color: '#856404', // Darker text for better readability
            border: '1px solid #ffeeba', // Border to match the background
          }}
        >
          <span>
            Olá, agora que você é um criador,{' '}
            <Link
              to="/creator-settings"
              className="fw-600"
              onClick={() => {
                setShowBannerMessage(false);
                setSessionObject('hasAlreadyClosedBanner', true);
              }}
              style={{
                textDecoration: 'underline',
                color: '#856404', // Match the text color for consistency
              }}
            >
              cadastre o seu plano mensal aqui.
            </Link>
          </span>
          <button
            className="btn-close"
            onClick={() => {
              setShowBannerMessage(false);
              setSessionObject('hasAlreadyClosedBanner', true);
            }}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '16px',
              cursor: 'pointer',
              color: '#856404', // Match the close button color
            }}
          >
            <i className="feather-x" />
          </button>
        </div>
      )}
    </>
  );
};

export default Header;
